import React from "react";
import cx from "classnames";

import SearchBar from "../../SearchBar";
import { convertSnakeToTitleCase } from "../../../utils";

import "./style.scss";
import DropDownFilter from "./dropdown";

const ArticlesFiltration = ({
  categories,
  setSelectedCategories,
  selectedLevel,
  setSelectedLevel,
  searchTerm,
  setSearchTerm,
}) => {
  const isAllCategorySelected = Object.values(categories).every(
    (cat) => cat.isActive
  );

  const _resetCategories = (_categories, _isActive) => {
    Object.keys(_categories).forEach(
      (name) => (_categories[name].isActive = _isActive)
    );
    return _categories;
  };

  const _onCategorySelect = (categories, [cat, { isMain }]) => {
    const newSelectedCategories = isAllCategorySelected
      ? _resetCategories(categories, false)
      : categories;

    setSelectedCategories({
      ...newSelectedCategories,
      [cat]: {
        isActive: !newSelectedCategories[cat].isActive,
        isMain,
      },
    });
  };

  return (
    <div id="learn-article-filtration">
      <div className="d-flex justify-content-center align-items-center mb-5">
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />

        <DropDownFilter
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          categories={categories}
          setSelectedCategories={setSelectedCategories}
          resetCategories={_resetCategories}
        />
      </div>
      <div className="d-flex justify-content-center mb-4">
        <div className="row justify-content-start justify-content-md-center">
          <button
            className={cx("button category", { active: isAllCategorySelected })}
            onClick={() => {
              const activeAllCategories = _resetCategories(categories, true);
              setSelectedCategories({ ...activeAllCategories });
            }}
          >
            All
          </button>
          {Object.entries(categories).map((entry, i) => {
            return (
              entry[1].isMain && (
                <button
                  key={`learn-article-filtration-category-${i}`}
                  className={cx("button category", {
                    active: !isAllCategorySelected && entry[1].isActive,
                  })}
                  onClick={() => _onCategorySelect(categories, entry)}
                >
                  {convertSnakeToTitleCase(entry[0])}
                </button>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ArticlesFiltration;
